<template>
  <div class="section">
    <h1>
      <span class="section-title">Contact</span>
      <span class="section-description">{{ $t('contact.title') }}</span>
    </h1>
    <div class="margin-bottom-60px">
      <p>ユーザーコミニュティで質問をすると、ユーザーの皆さんや弊社のサポート事務局がお答えします。<br>
        最新のアップデート情報や、ユーザー同士でのコミュニティとしてもご利用ください💁</p>
      <a href="https://forum.hstorage.io" rel="noreferrer" target="_blank">
        <b-button class="margin-top-30px is-info has-text-weight-bold" icon-pack="fab" icon-left="discourse"
          rounded>ユーザーコミニュティに参加する</b-button>
      </a>
    </div>
  </div>
</template>

<script>
import appConfig from "../app.config.json";
import { useSeoHead } from "@/helpers/seo";

export default {
  name: "Contact",
  created() {
    // ページのメタ情報を設定
    useSeoHead({
      base: '/contact',
      locale: this.$i18n.locale,
      title: `${this.$t('contact.title')} | ${appConfig[this.$i18n.locale].title}`,
      description: appConfig[this.$i18n.locale].description.contact,
    })

    // tawk.ioウィジェットをオープン（最大化）
    this.initializeTawkWidget();
  },
  methods: {
    initializeTawkWidget() {
      // ウィジェットが読み込まれているかを確認
      const checkTawkWidget = () => {
        // 複数の方法でtawk.ioAPIにアクセスを試行
        let tawkAPI = null;

        if (this.$tawkMessenger) {
          tawkAPI = this.$tawkMessenger;
        } else if (window.Tawk_API) {
          tawkAPI = window.Tawk_API;
        }

        if (tawkAPI) {
          try {
            // ログインユーザーの場合は、ユーザー情報を設定
            if (this.$store.state.isLoggedIn && tawkAPI.setAttributes) {
              tawkAPI.setAttributes({
                name: this.$store.state.user.name,
                email: this.$store.state.user.email,
              }, (error) => {
                if (error) {
                  console.error('tawk.io setAttributes error:', error);
                }
              });
            }

            // ウィジェットを最大化
            if (tawkAPI.maximize) {
              tawkAPI.maximize();
            }
          } catch (error) {
            console.error('tawk.io initialization error:', error);
          }
        } else {
          // ウィジェットがまだ読み込まれていない場合は再試行
          setTimeout(checkTawkWidget, 200);
        }
      };

      // 初回チェック
      setTimeout(checkTawkWidget, 100);
    }
  }
}
</script>

<style scoped></style>
